import React, { Fragment, useState } from "react";
import { Form, Input, message, Modal, Switch } from "antd";
import { HomeRepository, HomeSection } from "../../../../../domain";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { useAppDispatch } from "../../../../../application/store";
import { loadHome } from "../../../../../application/home-slice";

const { useForm, Item } = Form;

type EditHomeSectionInfoModalProps = {
  visible: boolean;
  section?: HomeSection;
  onClose: () => void;
};

const EditHomeSectionInfoModal: React.FC<EditHomeSectionInfoModalProps> = ({
  visible,
  onClose,
  section,
}) => {
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const submit = async () => {
    try {
      if (section === undefined) return;
      setIsLoading(true);
      let products: string[] = [];
      for (let index = 0; index < 10; index++) {
        const element = form.getFieldValue(`productId${index + 1}`);
        if (element === "") continue;
        if (element !== undefined) products.push(element.toString());
        else {
          if (section.items.length > index)
            products.push(section?.items[index]?.product.id.toString());
        }
      }
      const res = await ServiceLocater.get<HomeRepository>(
        Services.HomeRepository
      ).editHomeSectionInfo(section.id, {
        title: form.getFieldValue("title"),
        description: form.getFieldValue("description"),
        active: form.getFieldValue("active"),
        products,
      });
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          onClose();
          message.success("اطلاعات ردیف با موفقیت ویرایش شد");
          dispatch(loadHome());
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      visible={visible}
      onOk={submit}
      bodyStyle={{ paddingBottom: 0 }}
      title={"ویرایش اطلاعات ردیف"}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      confirmLoading={isLoading}
      destroyOnClose
    >
      <Form form={form}>
        {section?.type === "Scroll" ? (
          <Fragment>
            <Item name="title" label={"عنوان"} required>
              <Input
                name="title"
                maxLength={100}
                defaultValue={section?.title}
              />
            </Item>
            <Item name="description" label={"توضیحات"} required>
              <Input.TextArea
                name="description"
                defaultValue={section?.description}
              />
            </Item>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) => {
              return (
                <Item
                  label={`محصول ${index}`}
                  name={`productId${index}`}
                  rules={[{ validateTrigger: "onSubmit", type: "integer" }]}
                >
                  <Input
                    name={`productId${index}`}
                    defaultValue={section?.items[index - 1]?.product.id}
                    onChange={(value) => {
                      form.setFields([
                        {
                          name: `productId${index}`,
                          value: value.target.value,
                        },
                      ]);
                    }}
                  />
                </Item>
              );
            })}
          </Fragment>
        ) : (
          <Fragment>
            <Item name="title" label={"عنوان"} required>
              <Input
                name="title"
                maxLength={100}
                defaultValue={section?.title}
              />
            </Item>
            <Item name="description" label={"توضیحات"} required>
              <Input.TextArea
                name="description"
                defaultValue={section?.description}
              />
            </Item>
          </Fragment>
        )}
        <Item name="active" label="فعال">
          <Switch defaultChecked={section?.isActive} />
        </Item>
      </Form>
    </Modal>
  );
};

export default EditHomeSectionInfoModal;
